"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminRefundDrinkCard = adminRefundDrinkCard;
exports.getDrinkCardRefundPage = getDrinkCardRefundPage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function getDrinkCardRefundPage(params) {
  return (0, _requestAuth.default)({
    url: '/drinkCardRefund/page',
    method: 'get',
    params: params
  });
}
function adminRefundDrinkCard(orderSn) {
  return (0, _requestAuth.default)({
    url: '/drinkCardRefund/adminRefund',
    method: 'post',
    params: {
      orderSn: orderSn
    }
  });
}